import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { pairwise } from 'rxjs/operators';
import { ParamPhoneMaskHn, ParamPhoneMaskNoHn } from 'src/app/@core/constants';
import { ObjectUtils } from 'src/app/@core/utils/object-utils';
import { City } from 'src/app/models/city';
import { Colony } from 'src/app/models/colony';
import { Nationality } from 'src/app/models/nationality';
import { OnbaseCatalogue } from 'src/app/models/onbase-catalogue';
import { Region } from 'src/app/models/region';
import { CityService } from 'src/app/services/city.service';
import { ColonyService } from 'src/app/services/colony.service';
import { NationalityService } from 'src/app/services/nationality.service';
import { OnbaseService } from 'src/app/services/onbase.service';
import { ParamsService } from 'src/app/services/params.service';
import { RegionService } from 'src/app/services/region.service';

@Component({
  selector: 'pos-company-address-information-step',
  templateUrl: './company-address-information-step.component.html',
  styleUrls: ['./company-address-information-step.component.sass']
})
export class CompanyAddressInformationStepComponent implements OnInit {


  @Input() companyAddressInformationForm: FormGroup = new FormGroup({
    localType: new FormControl("", Validators.required),
    country: new FormControl("", Validators.required),
    deparment: new FormControl("", Validators.required),
    city: new FormControl("", Validators.required),
    neighborhood: new FormControl("", Validators.required),
    street: new FormControl("", Validators.required),
    street2: new FormControl("", Validators.required),
    street3: new FormControl("", Validators.required),
    street4: new FormControl("", Validators.required),
    street5: new FormControl("", Validators.required),
    companyPhone: new FormControl("", Validators.required),
    companyExtension: new FormControl(""),
  });

  @Input() onbaseCatalogue: OnbaseCatalogue = new OnbaseCatalogue();

  @Input() isEdit = false;
  @Input() readonly = false;
  nationalities: Array<Nationality> = [];
  cities: Array<City> = [];
  departments: Array<Region> = [];
  neighborhoods: Array<Colony> = [];
  localTypes: Array<{ key: string, value: string }> = [];
  filterLocalTypes = [
    "Z005",
    "Z006",
    "Z007"
  ]

  phoneMaskHN: string = "";
  phoneMaskNonHN: string = "";
  currentMask: string = "";
  constructor(private nationalityService: NationalityService, private cityService: CityService, private regionService: RegionService, private colonyService: ColonyService, private paramService: ParamsService, private onbaseService: OnbaseService) {
  }

  async ngOnInit(): Promise<void> {
    if (this.onbaseCatalogue.economicActivity.length == 0) {
      this.onbaseCatalogue = (await this.onbaseService.readOnBaseCatalogue().toPromise()).response;
    }
    this.nationalities = (await this.nationalityService.readNationalities().toPromise()).response.content;
    this.phoneMaskHN = (await this.paramService.readParam(ParamPhoneMaskHn).toPromise()).response.value;
    this.phoneMaskNonHN = (await this.paramService.readParam(ParamPhoneMaskNoHn).toPromise()).response.value;
    this.localTypes = ObjectUtils.objectToArray(this.onbaseCatalogue.homeType).filter(f => this.filterLocalTypes.includes(f.key));
    await this.changeCountry({ code: this.companyAddressInformationForm.get("country")?.value, name: "", country: "" }, false);

    if (this.isEdit) {
      await this.changeCountry({ code: this.companyAddressInformationForm.get("country")?.value, name: "", country: "" }, false);
      await this.changeDepartment({ country: this.companyAddressInformationForm.value.country, id: '', name: '', region: this.companyAddressInformationForm.value.deparment }, false)
      await this.changeCity({ cityCode: this.companyAddressInformationForm.value.city, code: '', countryCode: '', name: '', regionCode: '' }, false);
    }

    this.companyAddressInformationForm.valueChanges.pipe(pairwise()).subscribe(async ([prev, next]) => {
      // if (next.country && prev.country != next.country && this.isEdit) {
      //   await this.changeCountry({ code: next.country, name: "", country: "" });
      // }
      if (next.deparment && next.deparment != prev.deparment && this.isEdit) {
        await this.changeDepartment({ country: next.country, id: '', name: '', region: next.deparment }, false)
      }
      if (next.city && next.city != prev.city && this.isEdit) {
        await this.changeDepartment({ country: next.country, id: '', name: '', region: next.deparment }, false)
        await this.changeCity({ cityCode: next.city, code: '', countryCode: '', name: '', regionCode: '' }, false);
      }

    })
  }

  async changeCountry(item: Nationality, reset: boolean = true): Promise<void> {
    this.departments = (await this.regionService.readRegions(item.code).toPromise()).response.content;

    this.resetFields(item, reset);
  }

  private resetFields(item: Nationality, reset: boolean) {
    if (item.code == "HN") {
      this.currentMask = this.phoneMaskHN;
    }
    else {
      this.currentMask = this.phoneMaskNonHN;
    }
    if (reset) {
      this.companyAddressInformationForm.get("deparment")?.reset();
      this.companyAddressInformationForm.get("city")?.reset();
      this.companyAddressInformationForm.get("neighborhood")?.reset();
      this.companyAddressInformationForm.get("street")?.reset();
      this.companyAddressInformationForm.get("companyPhone")?.reset();
    }
    this.companyAddressInformationForm.get("deparment")?.markAsDirty();
    this.companyAddressInformationForm.get("city")?.markAsDirty();
    this.companyAddressInformationForm.get("neighborhood")?.markAsDirty();
    this.companyAddressInformationForm.get("street")?.markAsDirty();
    this.companyAddressInformationForm.get("companyPhone")?.markAsDirty();
    this.cities = [];
    this.neighborhoods = [];

  }

  async changeDepartment(item: Region, reset: boolean = true): Promise<void> {
    this.cities = (await this.cityService.readCities(item.country, item.region).toPromise()).response.content;
    if (reset) {
      this.companyAddressInformationForm.get("neighborhood")?.reset();
      this.companyAddressInformationForm.get("city")?.reset();
    }
  }

  async changeCity(item: City, reset: boolean = true): Promise<void> {
    this.neighborhoods = (await this.colonyService.readColonies(item.cityCode).toPromise()).response.content;
    if (reset) {
      this.companyAddressInformationForm.get("neighborhood")?.reset();
    }
  }


}
